module.exports = __webpack_public_path__ + "img/red_008.57d00468.png";